import { User } from "../../../dto/user"
import httpClient from "../../../service/api"

export const save = async (user:User) : Promise<void> => {
  console.log('User ', user)

  if (user.id) {
    await httpClient.post('/api/user/update', {
      ...user,
      password : undefined,
      passwordConfirm : undefined
    })

    if (user.password) {
      await httpClient.post('/api/user/password/update', { id : user.id, password: user.password })
    }

  } else {
    await httpClient.post('/api/user/create', {...user, organizations : []})
  }
}

